<template>
  <section class="cookie-consent" v-if="!hasShown">
    <div class="cookie-consent__body">
      Weboldalunkon - az <router-link to="/adatvedelmi-tajekoztato" class="cookie-consent__link">Adatvédelmi Tájékoztatóban</router-link> foglaltaknak megfelelően - a felhasználói élmény növelése érdekében cookie fájlokat ("sütiket") használunk.
    </div>

    <div class="cookie-consent__button text--center-xs">
      <button type="button" class="btn btn--primary block-xs" @click.prevent="accept">Rendben</button>
    </div>
  </section>
</template>

<script>
  import { getCookie, setCookie } from '../utils/cookie'

  export default {
    data: () => ({
      cookieName: 'MeloStockCookieConsentAccepted',
      delay: 500,
      isOpenClass: 'is-open',
      openTimeout: null
    }),

    mounted () {
      if (typeof getCookie(this.cookieName) === 'object') {
        this.init()
      }
    },

    beforeDestroy () {
      clearTimeout(this.openTimeout)
    },

    computed: {
      hasShown () {
        return getCookie(this.cookieName)
      }
    },

    methods: {
      init () {
        this.openTimeout = setTimeout(this.open, this.delay)
      },

      open () {
        this.$el.classList.add(this.isOpenClass)
      },

      close () {
        this.$el.classList.remove(this.isOpenClass)
      },

      accept () {
        setCookie({ cookieName: this.cookieName, value: true })
        this.close()
        this.$emit('on-accept')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CookieConsent.vue?1d0ac4fa